import { combineReducers } from "redux";
import { rootReducer } from "./FetchRecord";

const allReducers = combineReducers({
    rootReducer:rootReducer
})

export default allReducers;